// extracted by mini-css-extract-plugin
export var actions = "_61-8";
export var arrow = "_61-5";
export var card = "_61-0";
export var cardWrapper = "_61-9";
export var fieldName = "_61-3";
export var newValue = "_61-6";
export var oldValue = "_61-4";
export var orangeGlowFade = "_61-c";
export var productSection = "_61-1";
export var scrollToBottom = "_61-b";
export var scrollToBottomAnchor = "_61-a";
export var scrollToBottomIcon = "_61-d";
export var showAllButton = "_61-7";
export var table = "_61-2";